import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { LaboratoriesService } from "../../../services/laboratories.service";
import { forkJoin } from "rxjs";
import { LaboratoryCertificateRequiringDto } from "../../../models/laboratory/laboratory-certificate-requirings.dto";
import { LaboratoryExaminationObjectDto } from "../../../models/laboratory/laboratory-examination-objects.dto";
import { LaboratoryExaminationTargetDto } from "../../../models/laboratory/laboratory-examination-targets.dto";
import { LaboratoryExaminationTypeDto } from "../../../models/laboratory/laboratory-examination-types.dto";
import { LaboratoryMaterialSourceDto } from "../../../models/laboratory/laboratory-material-sources.dto";
import { LaboratoryRecommendationDto } from "../../../models/laboratory/laboratoy-recommendations.dto";
import { LaboratoryResultDeliveryTypeDto } from "../../../models/laboratory/laboratory-result-delivery-types.dto";
import { LaboratorySamplingPointDto } from "../../../models/laboratory/laboratory-sampling-points.dto";
import { RequestWaterSampling } from "../../../models/request/request-water-sampling/request-water-sampling";
import { LaboratoryExaminationTypeIndicatorDto } from "../../../models/laboratory/laboratory-examination-type-indicator.dto";
import { LaboratoryIndicatorDto } from "../../../models/laboratory/laboratory-indicator.dto";
import { DialogService } from "@progress/kendo-angular-dialog";
import { CheckboxItem, CheckboxSelectorComponent } from "../../checkbox-selector/checkbox-selector.component";
import { KeyValueObject } from "../../../models/core/KeyValueObject";
import { LaboratoryRequestIndicatorDto } from "../../../models/laboratory/laboratory-request-indicator.dto";
import { RequestWaterSamplingsService } from "../../../services/request-water-samplings.service";
import { StepperItem } from "../../stepper/app-stepper.component";
import { WizardBaseComponent } from "../../wizard-base/wizard-base.component";
import { ActionDataResult } from "../../../models/core/ActionDataResult";

@Component({
    selector: 'create-request-water-sampling',
    templateUrl: './create-request-water-sampling.component.html',
    styleUrls: ['./create-request-water-sampling.component.scss',
        '../../../../../vendor/libs/ngx-perfect-scrollbar/ngx-perfect-scrollbar.scss',
        '../../../../../vendor/libs/angular2-ladda/angular2-ladda.scss']
})
export class CreateRequestWaterSamplingComponent extends WizardBaseComponent {
    
    @Input() requestId: number;
    @Input() contentHeight: number = 640;

    private otherCode: string = 'other';
    private bottleCode: string = 'bottle';

    currentStepNumber = 1;
    steps: StepperItem[] = [];

    requestWaterSampling: RequestWaterSampling = null;
    requestIndicators: LaboratoryRequestIndicatorDto[] = [];

    loading: boolean;
    dataSaving: boolean;

    certificateRequirings: LaboratoryCertificateRequiringDto[] = [];
    examinationObjects: LaboratoryExaminationObjectDto[] = [];
    examinationTargets: LaboratoryExaminationTargetDto[] = [];
    examinationTypes: LaboratoryExaminationTypeDto[] = [];
    materialSources: LaboratoryMaterialSourceDto[] = [];
    recommendations: LaboratoryRecommendationDto[] = [];
    resultDeliveryTypes: LaboratoryResultDeliveryTypeDto[] = [];
    samplingPoints: LaboratorySamplingPointDto[] = [];
    examinationTypeIndicators: LaboratoryExaminationTypeIndicatorDto[] = [];
    indicators: LaboratoryIndicatorDto[] = [];

    constructor(
        private laboratoriesService: LaboratoriesService,
        private requestWaterSamplingsService: RequestWaterSamplingsService,
        private dialogService: DialogService
    ) { 
        super();
    }

    initData() {
        this.loading = true;
        this.requestWaterSampling = new RequestWaterSampling();

        this.requestWaterSamplingsService.getByRequest(this.requestId).subscribe(resp => {
            if (resp == null) {
                this.requestWaterSampling = new RequestWaterSampling();
            }
            else {
                this.requestWaterSampling = resp;
                this.requestIndicators = resp.requestIndicators;
            }

            this.buildSteps();

            const certificateRequirings$ = this.laboratoriesService.getAllCertificateRequirings();
            const examinationObjects$ = this.laboratoriesService.getAllExaminationObjects();
            const examinationTargets$ = this.laboratoriesService.getAllExaminationTargets();
            const examinationTypes$ = this.laboratoriesService.getAllExaminationTypes();
            const materialSources$ = this.laboratoriesService.getAllMaterialSources();
            const recommendations$ = this.laboratoriesService.getAllRecommendations();
            const resultDeliveryTypes$ = this.laboratoriesService.getAllResultDeliveryTypes();
            const samplingPoints$ = this.laboratoriesService.getAllSamplingPoints();
            const examinationTypeIndicators$ = this.laboratoriesService.getAllExaminationTypeIndicators();
            const indicators$ = this.laboratoriesService.getAllIndicators();
    
            forkJoin(
                certificateRequirings$, 
                examinationObjects$, 
                examinationTargets$,
                examinationTypes$,
                materialSources$,
                recommendations$,
                resultDeliveryTypes$,
                samplingPoints$,
                examinationTypeIndicators$,
                indicators$
            ).subscribe(([
                certificateRequirings, 
                examinationObjects, 
                examinationTargets,
                examinationTypes,
                materialSources,
                recommendations,
                resultDeliveryTypes,
                samplingPoints,
                examinationTypeIndicators,
                indicators
            ]) => {
                this.certificateRequirings = certificateRequirings.data;
                this.examinationObjects = examinationObjects.data;
                this.examinationTargets = examinationTargets.data;
                this.examinationTypes = examinationTypes.data;
                this.materialSources = materialSources.data;
                this.recommendations = recommendations.data;
                this.resultDeliveryTypes = resultDeliveryTypes.data;
                this.samplingPoints = samplingPoints.data;
                this.examinationTypeIndicators = examinationTypeIndicators.data;
                this.indicators = indicators.data;
    
                this.refreshStepStatuses();
                this.loading = false;
            });
        });
    }

    buildSteps() {
        this.steps = [
            { number: 1, name: 'Объект испытаний, источник пробы, точка отбора', checkSuccess: () => { 
                return this.examinationObjectValid && this.materialSourceValid && this.samplingPointValid
            } },
            { number: 2, name: 'Тип анализа и определяемые показатели', checkSuccess: () => { 
                return this.indicatorsValid
            } },
            { number: 3, name: 'Цель исследования и заключение о соответствии', checkSuccess: () => {
                return this.examinationTargetValid && this.requestWaterSampling.laboratoryCertificateRequiringId != null
            } },
            { number: 4, name: 'Способ получения результатов и рекомендации', checkSuccess: () => {
                return this.requestWaterSampling.laboratoryResultDeliveryTypeId != null &&
                        this.requestWaterSampling.laboratoryRecommendationId != null;
            } }
        ] as StepperItem[];
    }
    
    saveStepChanges(afterAction: () => void) {
        this.saveChangesImpl(false, afterAction);
    }

    saveChanges() {
        this.saveChangesImpl(true, () => {});
    }
   
    saveChangesImpl(initChangeStatus: boolean, afterAction: () => void) {
        this.dataSaving = true;

        this.requestWaterSampling.requestId = this.requestId;
        this.requestWaterSampling.requestIndicators = this.requestIndicators;

        if (this.requestWaterSampling.requestWaterSamplingId == null || this.requestWaterSampling.requestWaterSamplingId == 0) {
            this.requestWaterSamplingsService.create(this.requestWaterSampling).subscribe(() => {
                this.requestWaterSamplingsService.getByRequest(this.requestId).subscribe(resp => {
                    this.requestWaterSampling = resp;
                    this.requestIndicators = resp.requestIndicators;

                    if (initChangeStatus) {
                        this.onContinueEvent.emit();
                    }
                    afterAction();
                    this.dataSaving = false;
                });
            });
        }
        else {
            this.requestWaterSamplingsService.update(this.requestWaterSampling, null, false, true).subscribe((resp: ActionDataResult<any>) => {
                if (resp.isSuccessful) {
                    if (initChangeStatus) {
                        this.onContinueEvent.emit();
                    }
                    afterAction();
                }
                else {
                    this.toggleCurrentStep(false);
                }

                this.dataSaving = false;
            });
        }
    }

    toggleCurrentStep(isSuccess: boolean) {
        let currentStep = this.steps.find(x => x.number == this.currentStepNumber);
        currentStep.isSuccess = isSuccess;
    }

    changeExaminationObject() {
        if (!this.examinationObjectIsBottle) {
            this.requestWaterSampling.manufactureDate = null;
            this.requestWaterSampling.supplier = null;
            this.requestWaterSampling.partNumber = null;
        }
        if (!this.examinationObjectIsOther) {
            this.requestWaterSampling.laboratoryExaminationObjectDescription = null;
        }
    }

    changeMaterialSource() {
        if (!this.materialSourceIsOther) {
            this.requestWaterSampling.laboratoryMaterialSourceDescription = null;
        }
    }

    changeSamplingPoint() {
        if (!this.samplingPointIsOther) {
            this.requestWaterSampling.laboratorySamplingPointDescription = null;
        }
    }

    changeExaminationType(examinationTypeId: number) {
        let newRequestIndicators = this.examinationTypeIndicators.filter(x => 
            x.laboratoryExaminationTypeId == examinationTypeId).map(x => {
            return {
                laboratoryIndicatorId: x.laboratoryIndicatorId
            } as LaboratoryRequestIndicatorDto;
        });
        this.requestIndicators = newRequestIndicators;
    }

    changeExaminationTarget() {
        if (!this.examinationTargetIsOther) {
            this.requestWaterSampling.laboratoryExaminationTargetDescription = null;
        }
    }

    openIndicatorsModal() {
        const dialogRef = this.dialogService.open({
            title: "Выбор определяемых показателей",
            content: CheckboxSelectorComponent,
            width: 540,
            height: 560
        });

        let dialog = <CheckboxSelectorComponent>dialogRef.content.instance;
        
        dialog.contentHeight = 480;
        dialog.items = this.indicators.map(x => {
            let checked = this.requestIndicators.some(i => i.laboratoryIndicatorId == x.laboratoryIndicatorId);
            return {
                id: x.laboratoryIndicatorId,
                name: x.name,
                disabled: checked,
                checked: checked
            } as CheckboxItem
        });

        dialog.onCancelEvent.subscribe(() => {
            dialogRef.close();
        });

        dialog.onContinueEvent.subscribe((indicatorIds: number[]) => {
            indicatorIds.forEach(id => {
                if (!this.requestIndicators.some(x => x.laboratoryIndicatorId == id)) {
                    this.requestIndicators.push({
                        laboratoryIndicatorId: id
                    } as LaboratoryRequestIndicatorDto);
                }
            });
            dialogRef.close();
        });
    }

    isEmpty(value: string) {
        return value == null || value.trim() == '';
    }

    deleteRequestIndicator(indicatorId: number) {
        this.requestIndicators = this.requestIndicators.filter(x => x.laboratoryIndicatorId != indicatorId);
    }

    getIndicatorName(indicatorId: number) {
        return this.indicators.find(x => x.laboratoryIndicatorId == indicatorId).name;
    }

    get examinationObjectValid(): boolean {
        let examinationObjectValid = this.requestWaterSampling.laboratoryExaminationObjectId != null;
        if (this.examinationObjectIsOther) {
            examinationObjectValid = !this.isEmpty(this.requestWaterSampling.laboratoryExaminationObjectDescription);
        }
        if (this.examinationObjectIsBottle) {
            examinationObjectValid = 
                this.requestWaterSampling.manufactureDate != null &&
                !this.isEmpty(this.requestWaterSampling.supplier) &&
                !this.isEmpty(this.requestWaterSampling.partNumber);
        }

        return examinationObjectValid;
    }

    get materialSourceValid(): boolean {
        let materialSourceValid = 
            this.requestWaterSampling.laboratoryMaterialSourceId != null ||
            this.examinationObjectIsBottle;
        if (this.materialSourceIsOther && !this.examinationObjectIsBottle) {
            materialSourceValid = !this.isEmpty(this.requestWaterSampling.laboratoryMaterialSourceDescription);
        }

        return materialSourceValid;
    }

    get samplingPointValid(): boolean {
        let samplingPointValid = 
            this.requestWaterSampling.laboratorySamplingPointId != null ||
            this.examinationObjectIsBottle;     
        if (this.samplingPointIsOther && !this.examinationObjectIsBottle) {
            samplingPointValid = !this.isEmpty(this.requestWaterSampling.laboratorySamplingPointDescription);
        }
        return samplingPointValid;
    }

    get indicatorsValid(): boolean {
        let indicatorsValid = this.requestIndicators.length > 0;
        return indicatorsValid;
    }

    get examinationTargetValid(): boolean {
        let examinationTargetValid = this.requestWaterSampling.laboratoryExaminationTargetId != null;
        if (this.examinationTargetIsOther) {
            examinationTargetValid = !this.isEmpty(this.requestWaterSampling.laboratoryExaminationTargetDescription);
        }
        return examinationTargetValid;
    }

    get canSave(): boolean {
        return this.examinationObjectValid &&
            this.materialSourceValid &&
            this.samplingPointValid &&
            this.indicatorsValid &&
            this.examinationTargetValid &&
            this.requestWaterSampling.laboratoryCertificateRequiringId != null &&
            this.requestWaterSampling.laboratoryResultDeliveryTypeId != null &&
            this.requestWaterSampling.laboratoryRecommendationId != null;
    }

    get examinationObjectIsBottle(): boolean {
        return this.examinationObjectHasCode(this.bottleCode);
    }

    get examinationObjectIsOther(): boolean {
        return this.examinationObjectHasCode(this.otherCode);
    }

    private examinationObjectHasCode(searchingCode: string) {
        if (this.requestWaterSampling.laboratoryExaminationObjectId) {
            let code = this.examinationObjects.find(x => 
                x.laboratoryExaminationObjectId == this.requestWaterSampling.laboratoryExaminationObjectId).code;
            return code == searchingCode;
        }
        
        return false;
    }

    get materialSourceIsOther(): boolean {
        if (this.requestWaterSampling.laboratoryMaterialSourceId) {
            let code = this.materialSources.find(x => 
                x.laboratoryMaterialSourceId == this.requestWaterSampling.laboratoryMaterialSourceId).code;
            return code == this.otherCode;
        }
        
        return false;
    }

    get samplingPointIsOther(): boolean {
        if (this.requestWaterSampling.laboratorySamplingPointId) {
            let code = this.samplingPoints.find(x => 
                x.laboratorySamplingPointId == this.requestWaterSampling.laboratorySamplingPointId).code;
            return code == this.otherCode;
        }
        
        return false;
    }

    get examinationTargetIsOther(): boolean {
        if (this.requestWaterSampling.laboratoryExaminationTargetId) {
            let code = this.examinationTargets.find(x => 
                x.laboratoryExaminationTargetId == this.requestWaterSampling.laboratoryExaminationTargetId).code;
            return code == this.otherCode;
        }
        
        return false;
    }
}